import { Alert, AlertDescription } from '../ui/alert'
import { AlertTriangle } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

export default function AccountDeletionAlert() {
  const { user } = useAuth()
  
  // Only show if user has requested account deletion
  if (!user || !user.accountDeletionRequestedAt) {
    return null
  }

  return (
    <Alert className="border-red-200 bg-red-50">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription className="text-red-800">
        Your account deletion has been requested. Your account will be permanently deleted soon. 
        Contact support if you want to cancel this request.
      </AlertDescription>
    </Alert>
  )
}